export enum DiceAnimationState {
  before = 'before',
  inProgress = 'inProgess',
  after = 'after',
  stop = 'stop',
}
